<div class="user-info">
  <img [src]="userPicture(user)" alt="">
  <div>
    <span>{{ userName(user) }}</span>
    <span>{{ userProperty(user) | translate }}</span>
  </div>
</div>
